/* 🤖 this file was generated by script */
export const wiconLink02 = {
  name: 'link_02',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17H7A5 5 0 017 7h2m6 10h2a5 5 0 000-10h-2m-8 5h10"/></svg>`,
};
